<template>
    <section class="select-section">
        <el-dialog :visible.sync="dialogVisible" width="70%" center
         min-width="750px">
            <p slot="title">{{title}}</p>
            <el-table :data="tableData" class="table_list" style="width: 100%" border>
                <el-table-column label="医生姓名">
                  <template slot-scope="scope">
                    <span>{{scope.row.title || '-'}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="职称">
                  <template slot-scope="scope">
                    <span>{{scope.row.job || '-'}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="科室">
                  <template slot-scope="scope">
                    <span>{{scope.row.department || '-'}}</span>
                  </template>
                </el-table-column>
            </el-table>
            <!-- <div class="pagination-wrap">
                <el-pagination class='pagination' @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
                </el-pagination>
            </div> -->
        </el-dialog>
    </section>
</template>

<script scoped>
import requestApi from "@/api/thirdManage/hospitalFolder";
export default {
  name: "doctorComponent",
  data() {
    return {
      title: "",
      tableData: [],
      dialogVisible: false,
      pageSize: 20,
      currentPage: 1,
      totalCount: 0,
    };
  },
  props: {
    timeRange: Array
  },
  mounted() {
  },
  methods: {
    open(title, id, hospitalId) {
      this.tableData = []
      this.getData(id,hospitalId)
      this.dialogVisible = true;
      this.title = title;
    },
    close() {
      this.dialogVisible = false;
    },
    getData(id,hospitalId) {
        var data = {
            hospitalId: hospitalId,
            start: this.timeRange[0] + ' 00:00:00',
            end: this.timeRange[1] + ' 23:59:59',
            courseId: id
        };
        requestApi.getDoctorById(data).then(res => {
            if (res.Success) {
              this.tableData = res.Data;
            } else {
              this.$message.error(res.Msg);
            }
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData();
    }
  }
};
</script>

<style type="text/less" lang="less" scoped>
.pagination{
  margin-top: 20px;
}
.select-section {
  .el-dialog__wrapper {
    background-color: rgba(0, 0, 0, 0.1);
  }
  .pagination-wrap{
    overflow: hidden;
  }
  .el-pagination {
    float: right;
  }
  .dialog-footer {
    margin-top: 40px;
  }
}
.search-row {
  margin-bottom: 10px;
  text-align: right;
  .input-with-select {
    width: 30%;
    min-width: 350px;
  }
  .search-select {
    width: 110px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/thirdManage/hospitalFolder/doctorComponent.vue